import React from 'react';

import styles from './AvailableJobs.css';
import Results from './Results';
import SearchForm from './SearchForm';

const AvailableJobs = ({
  activeCrew,
  customers,
  detailEnabled,
  dropdowns,
  financialEnabled,
  form,
  jobs,
  loading,
  locationEnabled,
  onCustomerSearch,
  onFormUpdate,
  onJobClick
}) => (
  <div className={styles.container}>
    <SearchForm
      customers={customers}
      dropdowns={dropdowns}
      form={form}
      loading={loading}
      onCustomerSearch={onCustomerSearch}
      onFormUpdate={onFormUpdate}
    />
    <Results
      activeCrew={activeCrew}
      className={styles.results}
      detailEnabled={detailEnabled}
      financialEnabled={financialEnabled}
      jobs={jobs}
      loading={loading}
      locationEnabled={locationEnabled}
      onJobClick={onJobClick}
    />
  </div>
);

export default AvailableJobs;
